import { CityDTO } from './CityDTO'

export class CityCollectionDTO {
  constructor(readonly cities: CityDTO[]) {}
}
